<template lang="html">
    <section class="contenedor-input type-text full-slot p-0 mb-0" v-if="centrosTrabajoEmpresa"
        :class="$route.name == 'propuesta-practicas' && isAlumno == true ? 'mb-0' : ''">
        <div class="container-info-popup">
            <label for="centroTrabajo">Centro de trabajo*
            </label>
            <template
                v-if="Object.values(centrosTrabajoEmpresa).length > 0 == false && $route.name == 'propuesta-practicas' && isAlumno == true">
                <div class="contenedor-input full-slot row-start mb-0">
                    <label class="mt-10">¿La dirección de realización de tus prácticas es la misma que la que has
                        indicado para la empresa?</label>
                    <div class="radio-container row-start">
                        <input type="radio" :value="true" id="showCheckDias1" v-model="centroTrabajoCheck"
                            v-validate="'required'" name="showCheckDias">
                        <label for="showCheckDias1">Sí</label>
                    </div>
                    <div class="radio-container row-start">
                        <input type="radio" :value="false" id="showCheckDias2" v-model="centroTrabajoCheck"
                            v-validate="'required'" name="showCheckDias">
                        <label for="showCheckDias2">No</label>
                    </div>
                </div>
            </template>

            <template v-else>
                <p class="mb-0" @click="newSucursal" v-if="Object.values(centrosTrabajoEmpresa).length > 0">Si el centro
                    de trabajo o sucursal no está entre las opciones disponibles,
                    puede <u class="cursor-pointer">crear uno nuevo</u>
                </p>
                <p class="mb-0" @click="newSucursal" v-else> <u class="cursor-pointer">Crear un nuevo centro de
                        trabajo</u>
                </p>
            </template>
            <!-- <popup-info :texto="'centroTrabajo_oferta'" :side="'center'"></popup-info> -->
        </div>
        <select name="centroTrabajo" v-model="sucursalId" @change="changeCentro"
            v-if="centrosTrabajoEmpresa && Object.values(centrosTrabajoEmpresa).length > 0">
            <option :value=null>-Seleccionar-</option>
            <option v-if="Object.values(centrosTrabajoEmpresa).length > 0 && centrosTrabajoEmpresa"
                v-for="(el, key) in centrosTrabajoEmpresa" :value="key">{{ el.nombre }}</option>
        </select>
        <!-- <span class='error' v-if="noCompletCentro == true">Este campo es requeridoo</span>
    <span class='error'>{{ errors.first('centroTrabajo') }}</span> -->
        <div v-if="centrosTrabajoEmpresa && openTableCentro && sucursalObj != null">
            <div v-if="saveBtn && loadingCentro == false" class="box-gray-content">
                <form @submit.prevent="handleSubmit">
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="nombre">Nombre del centro*</label>
                        <input type="text" name="nombre" v-model="sucursalObj.nombre" v-validate="'required|min:3'"
                            @change="saveBtn = true">
                        <span class='error'>{{ errors.first('nombre') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot">
                        <label for="cifempresa">CIF</label>
                        <input type="text" v-model="sucursalObj.cif" v-validate="'min:3'" name="cifempresa"
                            :class="[{ 'has-error': errors.has('cifempresa') }]" autocomplete="none"
                            @change="saveBtn = true">
                        <span class='error'>{{ errors.first('cifempresa') }}</span>
                    </div>

                    <div class="contenedor-input type-text one-slot">
                        <label for="pais">{{ $t('oferta.pais') }}*</label>
                        <select name="pais" v-model="sucursalObj.idPais" v-validate="'required'" v-if="$t('paisesList')"
                            @change="saveBtn = true">
                            <option value="">-Seleccionar-</option>
                            <option
                                v-for="(el, key) in Object.entries($t('paisesList')).sort(([, valorA], [, valorB]) => valorA.localeCompare(valorB))"
                                :value="el[0]">{{ el[1] }}</option>
                        </select>
                        <span class='error'>{{ errors.first('pais') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot">
                        <label for="provincia">{{ $t('oferta.provincia') }}*</label>
                        <input type="text" name="provincia" v-model="sucursalObj.provincia"
                            v-if="sucursalObj.idPais != 1" v-validate="'required|min:3'" @change="saveBtn = true">
                        <select v-validate="'required'" name="provincia" v-model="sucursalObj.provincia" v-else>
                            <option value="">-Selecciona una provincia-</option>
                            <option v-if="!!provinciasComplet" v-for="(el, key) in provinciasComplet"
                                :value="el.idProvincia">
                                {{ el.nameProvincia }}</option>
                        </select>
                        <span class='error'>{{ errors.first('provincia') }}</span>
                    </div>
                    <div class="contenedor-input one-slot">
                        <label for="localidad">Localidad*</label>
                        <select name="localidad" v-model="sucursalObj.idLocalidad" v-validate="'required'"
                            v-if="sucursalObj.idPais == 1 && provinciasComplet[sucursalObj.provincia]"
                            @change="saveBtn = true">
                            <option :value="null">{{ $t('registro.selecciona_localidad') }}</option>
                            <option v-if="!!provinciasComplet[sucursalObj.provincia]['localidades']"
                                v-for="(el, key) in provinciasComplet[sucursalObj.provincia]['localidades']"
                                :value="key">{{ el
                                }}
                            </option>
                        </select>
                        <input type="text" name="localidad" v-model="sucursalObj.localidad" v-else
                            v-validate="'required'">
                        <span class='error'>{{ errors.first('localidad') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="cp">{{ $t('registro.cp') }}*</label>
                        <input type="text" name="cp" v-model="sucursalObj.cp" v-validate="'required|numeric|min:5'"
                            autocomplete="nope" @change="saveBtn = true">
                        <span class='error'>{{ errors.first('cp') }}</span>
                    </div>
                    <div class="contenedor-input type-text full-slot -wo-margin">
                        <label for="direccion">Dirección*</label>
                        <input type="text" name="direccion" v-model="sucursalObj.direccion"
                            v-validate="'required|min:3'" @change="saveBtn = true">
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="telefono">Teléfono</label>
                        <input type="text" name="telefono" v-model="sucursalObj.telefono"
                            v-validate="'max:14|min:9|integer'" @change="saveBtn = true">
                        <span class='error'>{{ errors.first('telefono') }}</span>
                    </div>

                    <div class="contenedor-input one-slot -wo-margin">
                        <label for="email">{{ $t('registro.email') }}</label>
                        <input type="text" name="email" v-model="sucursalObj.email" v-validate="'email'"
                            @change="saveBtn = true">
                        <span class='error'>{{ errors.first('email') }}</span>
                    </div>
                    <div class="contenedor-input one-slot -wo-margin">
                        <label for="nombreContacto">Persona de contacto</label>
                        <input type="text" name="nombreContacto" v-model="sucursalObj.nombreContacto"
                            @change="saveBtn = true">
                    </div>
                    <div class="contenedor-input  row-start">
                        <span class="btn -solid-primary mb-0" @click="saveSucursal" v-if="saveBtn">{{ $t('guardar')
                        }}</span>
                    </div>
                </form>
            </div>

            <template v-else>
                <div class="box-gray-content" v-if="isEmpresa">
                    <div class="container-loading row-center w-100" v-if="loadingCentro">
                        <loading></loading>
                    </div>
                    <div v-if="loadingCentro == false" class="container" style="margin-top:-10px;">
                        <div class="contenedor-datos row-start">
                            <h3 class="dato-cv" v-if="sucursalObj.nombre">
                                <strong>Nombre del centro: </strong>
                                {{ sucursalObj.nombre }}
                            </h3>
                            <h3 class="dato-cv" v-if="sucursalObj.cif">
                                <strong>CIF: </strong>
                                {{ sucursalObj.cif }}
                            </h3>
                            <h3 class="dato-cv" v-if="sucursalObj.cp">
                                <strong>{{ $t('registro.cp') }}: </strong>
                                {{ sucursalObj.cp }}
                            </h3>
                            <h3 class="dato-cv" v-if="sucursalObj.direccion">
                                <strong>Dirección: </strong>
                                <template v-if="!!sucursalObj.direccion">
                                    {{ sucursalObj.direccion }}
                                </template>
                                <template v-if="!!sucursalObj.direccionNumero">
                                    , {{ $t('registro.numero') }}:{{ sucursalObj.direccionNumero }}
                                </template>
                                <template v-if="!!sucursalObj.direccionEscalera">
                                    , {{ $t('registro.escalera') }}:{{ sucursalObj.direccionEscalera }}
                                </template>
                                <template v-if="!!sucursalObj.direccionPuerta">
                                    , {{ $t('registro.puerta') }}:{{ sucursalObj.direccionPuerta }}
                                </template>
                                <template v-if="!!sucursalObj.direccionPiso">
                                    , {{ $t('registro.piso') }}:{{ sucursalObj.direccionPiso }}
                                </template>
                                {{ sucursalObj.idLocalidad }}
                                <!-- <template v-if="!!sucursalObj.idLocalidad">
                                    , {{ provinciasComplet[sucursalObj.provincia].localidades[sucursalObj.idLocalidad]
                                    }}
                                </template>
                                <template v-else>
                                    <template v-if="!!sucursalObj.localidad">
                                        , {{ sucursalObj.localidad }}
                                    </template>
                                </template> -->
                                <template v-if="!!provinciasComplet[sucursalObj.provincia]">
                                    , {{ provinciasComplet[sucursalObj.provincia].nameProvincia }}
                                </template>
                                <template v-else>
                                    <template v-if="!!sucursalObj.provinciaOtros">
                                        , {{ sucursalObj.provinciaOtros }}
                                    </template>
                                    <template v-if="sucursalObj.provincia">
                                        , {{ sucursalObj.provincia }}
                                    </template>
                                </template>
                                <template v-if="!!sucursalObj.idPais">
                                    , {{ $t('paisesList')[sucursalObj.idPais] }}
                                </template>
                                <template v-if="!!sucursalObj.cp">
                                    , {{ sucursalObj.cp }}
                                </template>
                            </h3>
                            <h3 class="dato-cv" v-if="sucursalObj.telefono">
                                <strong>Teléfono: </strong>
                                {{ sucursalObj.telefono }}
                            </h3>
                            <h3 class="dato-cv" v-if="sucursalObj.email">
                                <strong>{{ $t('registro.email') }}: </strong>
                                {{ sucursalObj.email }}
                            </h3>
                            <h3 class="dato-cv" v-if="sucursalObj.nombreContacto">
                                <strong>Persona de contacto: </strong>
                                {{ sucursalObj.nombreContacto }}
                            </h3>

                        </div>
                    </div>
                </div>
            </template>
        </div>
    </section>

</template>

<script lang="js">
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex';
import VeeValidate from 'vee-validate';
import loading from '@/components/parts/loading';
import axios from 'axios'
Vue.use(VeeValidate);
export default {
    name: 'centro-trabajo',
    props: ['idSucursal', 'centrosTrabajoEmpresa', 'idEmpresa', 'dataEmpresa'],
    components: {
        'loading': loading
    },
    mounted() {
        if (this.isEmpresa && !!!window.location.search) {
            this.requestDatosEmpresa()
        }
        if (this.idSucursal && this.centrosTrabajoEmpresa) {
            this.sucursalId = this.idSucursal;
            this.sucursalObj = this.centrosTrabajoEmpresa[this.idSucursal]
            this.$emit('setSucursal', this.sucursalObj);
        }

    },
    data() {
        return {
            clicked: false,
            openTableCentro: false,
            saveBtn: false,
            loadingCentro: false,
            sucursalObj: null,
            sucursalId: null,
            centroTrabajoCheck: null,
        }
    },
    computed: {
        ...mapGetters({
            provincias: 'getProvincias',
            dominios: 'getDominios',
            isAlumno: 'isAlumno',
            isEmpresa: 'isEmpresa',
            provinciasComplet: 'getProvinciasComplet',

        })
    },
    methods: {
        ...mapActions(['requestDatosEmpresa', 'requestSaveCentro']),

        emitirDatosEmpresa() {
            this.openTableCentro = false;
            this.sucursalObj = {
                "idCentro": "nuevo",
                "nombre": this.dataEmpresa.nombreComercial,
                "cif": this.dataEmpresa.cif,
                "direccion": this.dataEmpresa.direccion,
                "idPais": this.dataEmpresa.pais,
                "provincia": this.dataEmpresa.provincia,
                "localidad": this.dataEmpresa.localidad,
                "idLocalidad": this.dataEmpresa.idLocalidad,
                "cp": this.dataEmpresa.cp
            };
            this.$emit('setSucursal', this.sucursalObj);
        },
        newSucursal() {
            this.openTableCentro = true,
                this.sucursalObj = {}
            this.saveBtn = true
        },
        changeCentro() {
            this.saveBtn = false;
            this.openTableCentro = true;
            if (this.sucursalId && this.centrosTrabajoEmpresa[this.sucursalId]) {
                this.sucursalObj = this.centrosTrabajoEmpresa[this.sucursalId];
                if (this.sucursalObj.idProvincia) {
                    this.sucursalObj.provincia = this.sucursalObj.idProvincia
                }
            } else {
                this.openTableCentro = false;
                this.sucursalObj = null;
            }
            this.$emit('setSucursal', this.sucursalObj);
        },
        saveSucursal() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.loadingCentro = true;
                    if (this.isEmpresa) {
                        this.requestSaveCentro(this.sucursalObj).then(result => {
                            if (result != null) {
                                this.loadingCentro = false;
                                this.saveBtn = false;
                                this.sucursalObj.idCentro = result;
                                // Establecer el ID seleccionado
                                this.sucursalId = result;
                                // Actualizar la lista de centros de trabajo usando Vue.set para reactividad
                                this.$set(this.centrosTrabajoEmpresa, result, { ...this.sucursalObj });
                                // Emitir el evento para notificar al componente padre
                                this.$emit('setSucursal', this.sucursalObj);

                                // Cerrar el formulario de edición
                                this.openTableCentro = true;
                            }
                        });
                    }
                    else {
                        // Puede venir como array o como objeto indexado por idCentro
                        if (Array.isArray(this.centrosTrabajoEmpresa)) {
                            this.centrosTrabajoEmpresa.push(this.sucursalObj)
                            this.sucursalObj.idCentro = null
                            this.loadingCentro = false;
                            this.saveBtn = false;
                            this.sucursalId = this.centrosTrabajoEmpresa.length - 1
                        } else if (this.centrosTrabajoEmpresa && typeof this.centrosTrabajoEmpresa === 'object') {
                            const tempId = this.sucursalObj.idCentro || 'nuevo'
                            this.sucursalObj.idCentro = tempId
                            this.$set(this.centrosTrabajoEmpresa, tempId, { ...this.sucursalObj })
                            this.loadingCentro = false;
                            this.saveBtn = false;
                            this.sucursalId = tempId
                        }
                        this.$emit('setSucursal', this.sucursalObj);
                    }
                }
            });

        },
    },
    watch: {
        idSucursal(newVal) {
            if (this.idSucursal) {
                this.sucursalId = this.idSucursal;
                this.sucursalObj = this.centrosTrabajoEmpresa[this.idSucursal]
            }
        },
        'centroTrabajoCheck': function () {
            if (this.centroTrabajoCheck) {
                this.emitirDatosEmpresa();
            } else {
                this.openTableCentro = true,
                    this.sucursalObj = {
                        "cif": this.dataEmpresa.cif
                    }
                this.saveBtn = true
            }
        },
        'dataEmpresa': {
            deep: true,
            handler() {
                if (this.centroTrabajoCheck === true) {
                    this.emitirDatosEmpresa();
                }
            }
        }
    },
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/parts/form/centro-trabajo.vue